import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {NavigationEnd, Router} from '@angular/router';
import { BreadcrumbService, Breadcrumb } from 'angular-crumbs';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import {filter} from 'rxjs/operators';
declare var gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    Location, {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    }
  ]
})
export class AppComponent implements AfterViewInit, OnDestroy  {
  private routerSubscription: Subscription;
  constructor(private titleService: Title, private breadcrumbService: BreadcrumbService, private translate: TranslateService, private router: Router) {

    if (sessionStorage.getItem('lang') == null || sessionStorage.getItem('lang') == undefined) {
      translate.use('mn');
      sessionStorage.setItem('lang', 'mn');
    } else {
      translate.use(sessionStorage.getItem('lang'));
    }
  }
  ngOnInit(): void {
    this.breadcrumbService.breadcrumbChanged.subscribe(crumbs => {
      this.titleService.setTitle(this.createTitle(crumbs));
    });
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  private createTitle(routesCollection: Breadcrumb[]) {
    const title = '“GOOD” ПЛАТФОРМ';
    const titles = routesCollection.filter((route) => route.displayName);

    if (!titles.length) { return title; }

    const routeTitle = this.titlesToString(titles);
    return `${title}${routeTitle}`;
  }


  ngAfterViewInit(): void {
    // subscribe to router events and send page views to Google Analytics
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        gtag('config', 'G-B0DNF9F1WW', {'page_path': event.urlAfterRedirects});
      });
  }
  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  private titlesToString(titles) {
    return titles.reduce((prev, curr) => {
      return `${prev} | ${curr.displayName}`;
    }, '');
  }
}
